import { render, staticRenderFns } from "./InputNumeric2.vue?vue&type=template&id=5b462d70&scoped=true"
import script from "./InputNumeric2.vue?vue&type=script&lang=js"
export * from "./InputNumeric2.vue?vue&type=script&lang=js"
import style0 from "./InputNumeric2.vue?vue&type=style&index=0&id=5b462d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b462d70",
  null
  
)

export default component.exports